<template lang="pug">
    v-card(
        style="height: 500px !important;"
        elevation="4"
        shaped
    )
        v-card-text yo world

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
        },
        components: {
        },
        props: {
            currentDayDashboardSummary: Object,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
        },
    });
</script>

<style lang="scss" scoped>
</style>